import ApiService from "@/common/api/api.service";

export const ScheduleService = {
    post(data) {
        ApiService.setHeader()
        return ApiService.post('schedule', data)
    },
    finish_attendance(id, data) {
        ApiService.setHeader()
        return ApiService.post(`schedule/${id}/finish`, data)
    },
    addItem(id, data) {
        ApiService.setHeader()
        return ApiService.post(`orders/${id}/items`, data)
    },
    deleteItem(id, itemID){
        ApiService.setHeader()
        return ApiService.delete(`orders/${id}/items/${itemID}`)
    },
    addItemAssistant(id, data) {
        ApiService.setHeader()
        return ApiService.post(`orders/${id}/assistant`, data)
    },
    start_attendance(id) {
        ApiService.setHeader()
        return ApiService.post(`schedule/${id}/attendance`, {})
    },
    get_payment_types() {
        ApiService.setHeader()
        return ApiService.get('payment-type')
    },
    get(slug) {
        ApiService.setHeader()
        return ApiService.get('schedule', slug)
    },
    getDaysOff(date) {
        ApiService.setHeader()
        return ApiService.get(`/schedule/days-off/${date}`)
    },
    delete(slug) {
        ApiService.setHeader()
        return ApiService.delete(`schedule/${slug}`)
    }
}
